var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{class:{
    'dp-table-head-cell': true,
    'dp-table-head-cell--truncated': _vm.truncated,
  },style:({
    width: _vm.widthString,
    textAlign: _vm.align ? _vm.align : null,
  })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }